// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 39) return "static/chunks/39-bc1c9b989a22490c.js";
	if (chunkId === 565) return "static/chunks/565-2ab28cb3486ad8e2.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"c6a3d99b5ba2584e","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"f37e47fca2035fd2","367":"08b50a1688b601f5","639":"a1a9962d8da6cadf","748":"ea0ca04966731287"}[chunkId] + ".js";
};